import { List } from 'immutable';
import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from '../core';

import * as actions from './subscriptionsActions';

const supportedDatasetPlatformsOverrides = new Map([
  ['acme', { supportedDatasetPlatforms: List(['ACME']) }],
  ['acme-apple', { supportedDatasetPlatforms: List(['ACME']) }],
  ['acme-google', { supportedDatasetPlatforms: List(['ACME']) }],
]);

const subscriptionsReducer = handleActions(
  {
    [actions.getSubscriptions]: (state) => state.merge({ isLoading: true }),
    [actions.updateSubscriptionDev]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.getSubscriptionsSuccess]: (state, { payload }) =>
      resourceUpserters.upsertResources(
        state,
        payload.merge({
          resources: payload.resources.map((subscription) =>
            subscription.merge(supportedDatasetPlatformsOverrides.get(subscription.productLineUriName)),
          ),
          replaceCollection: true,
        }),
      ),
    [actions.getSubscriptionsFailure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const SUBSCRIPTIONS_REDUCER_KEY = 'subscriptionsStore';
export default subscriptionsReducer;
